<template>
  <div>
    <Benchmark
      v-if="benchmarkDialogVisible"
      v-model="benchmarkDialogVisible"
      :rows="rowsRaw"
      :benefits="benefits"
    ></Benchmark>
    <v-toolbar dense flat color="yellow lighten-3" class="mb-0 pb-0" height="38">
      <v-spacer></v-spacer>
      <v-btn
        outlined
        small
        @click="benchmarkDialogVisible = !benchmarkDialogVisible"
        class="mb-0 mr-2"
        >Benchmark</v-btn
      >
      <v-btn outlined small @click="exportToExcel" color="primary" class="mb-0">Export</v-btn>
    </v-toolbar>
    <v-simple-table style="width:100%">
      <template v-slot:default>
        <thead>
          <tr class="yellow lighten-3">
            <th style="border-bottom:0;" class="text-xs-left title"></th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>P10</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>P25</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>P50</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>P75</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>P90</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>Mean</strong>
            </th>
            <th style="border-bottom:0;" class="text-xs-left">
              <strong>Data Points</strong>
            </th>
          </tr>
          <tr class="pa-0" v-if="loading">
            <th colspan="8" class="pa-0" style="height:4px;">
              <v-progress-linear indeterminate></v-progress-linear>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="r in rows">
            <tr :key="r.value + '1'" :class="getClass(r)" v-if="hasIncumbents(r, benefits)">
              <td style="font-size:0.75rem;">
                <v-tooltip top v-if="r.tip">
                  <template v-slot:activator="">
                    <strong>{{ r.text }} (p.a.)</strong>
                    <span>{{ r.tip }}</span>
                  </template>
                </v-tooltip>
                <strong v-if="!r.tip">{{ r.text }} (p.a.)</strong>
              </td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].p10 | currency }}</td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].p25 | currency }}</td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].p50 | currency }}</td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].p75 | currency }}</td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].p90 | currency }}</td>
              <td style="font-size:0.75rem;">{{ pvalRows[r.value].mean | currency }}</td>
              <td style="font-size:0.75rem;" class="">
                <strong
                  >{{ benefits[r.value] ? benefits[r.value].length : 0 }}/{{ totalPositions }} ({{
                    ((benefits[r.value].length / totalPositions) * 100) | percentage
                  }})
                </strong>
              </td>
              <!-- <td style="font-size:0.75rem;" class="text-xs-center">
            <strong>{{benefits[r.value].length / totalPositions*100|percentage}}</strong>
          </td> -->
            </tr>
            <tr
              :key="r.value + '2'"
              v-if="hasIncumbents(r, benefits) && r.components"
              class="percent yellow lighten-5 black--text text--darken-3 body-1"
            >
              <td style="font-size:0.75rem;">As % of Basic Salary</td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].p10AsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].p25AsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].p50AsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].p75AsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].p90AsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;">
                {{ (pvalRows[r.value].meanAsPcOfABS * 100) | percentage }}
              </td>
              <td style="font-size:0.75rem;" class="text-xs-center"></td>
              <!-- <td class="text-xs-center"> </td> -->
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import Vue from 'vue';
import download from 'downloadjs';
import Benchmark from './Benchmark.vue';
import percentage from '../util/percentage';
import currency from '../util/currency';
import pval from '../util/pval';

export default Vue.extend({
  filters: {
    percentage,
    currency,
  },
  props: {
    sectors: {
      type: Array,
    },
    onetJobGroups: {
      type: Array,
    },
    countries: {
      type: Array,
    },
    jobClasses: {
      type: Array,
    },
    companyBenefits: {
      type: Array,
    },
    loading: Boolean,
    exchangeRate: Object,
  },
  data() {
    return {
      benchmarkDialogVisible: false,
      c1c6View: false,
      rowsRaw: [
        { value: 'salaryUSD', text: 'C1: Basic Salary', isSummary: true },
        {
          value: 'allowanceUSD',
          text: 'Allowance',
          isSummary: false,
          components: true,
        },
        {
          value: 'fixedCashUSD',
          text: 'C2: Fixed Cash',
          isSummary: true,
        },
        {
          value: 'bonusUSD',
          text: 'Bonus',
          isSummary: false,
          components: true,
        },
        {
          value: 'discretionaryBonusUSD',
          text: 'Discretionary Bonus',
          isSummary: false,
          components: true,
        },
        {
          value: 'rawTotalCashUSD',
          text: 'C3: Total Cash',
          isSummary: true,
        },
        {
          value: 'shareBasedPaymentUSD',
          text: 'Share-Based Payment',
          components: true,
        },
        {
          value: 'deferredCashUSD',
          text: 'Deferred Cash',
          components: true,
        },
        {
          value: 'stockAwardUSD',
          text: 'Stock Award',
          isSummary: false,
          components: true,
        },
        {
          value: 'optionAwardUSD',
          text: 'Option Award',
          isSummary: false,
          components: true,
        },
        {
          value: 'nonEquityUSD',
          text: 'Non Equity',
          isSummary: false,
          components: true,
        },
        {
          value: 'rawTotalDirectCompensationUSD',
          text: 'C4: Total Direct Compensation',
          isSummary: true,
        },
        {
          value: 'benefitsInKindUSD',
          text: 'Benefits-in-Kind',
          components: true,
        },
        {
          value: 'totalRemunerationUSD',
          text: 'C5: Total Remuneration',
          isSummary: true,
        },
        { value: 'socialContributionUSD', text: 'Social Contribution', components: true },
        {
          value: 'pensionUSD',
          text: 'Pension',
          isSummary: false,
          components: true,
        },
        {
          value: 'totalCostUSD',
          text: 'C6: Total Cost to Company',
          isSummary: true,
          isTotalCost: true,
        },
        { value: 'directorFeeUSD', text: 'Director Fee' },
        {
          value: 'otherUSD',
          text: 'Others',
        },
      ],
      rowsC1c6: [
        { value: 'salaryUSD', text: 'C1: Basic Salary', isSummary: false },
        // eslint-disable-next-line
        {
          value: 'allowanceUSD',
          text: 'Fixed Allowance',
          isSummary: false,
          components: ['allowanceUSD'],
          tip: 'Excluding perquisites such as Car allowance in lieu of car',
        },
        {
          value: 'fixedCashUSD',
          text: 'C2: Fixed Cash',
          isSummary: true,
        },
        {
          value: 'bonusUSD',
          text: 'Variable Cash',
          isSummary: false,
          tip: 'Includes performance bonus, commission',
          components: ['bonusUSD'],
        },
        {
          value: 'totalCashUSD',
          text: 'C3: Total Cash',
          isSummary: true,
        },
        {
          value: 'longTermIncentiveUSD',
          text: 'Long-term Incentive',
          isSummary: false,
          tip: 'Eg. equity, stock plan, Long-term cash',
          components: ['longTermIncentiveUSD'],
        },
        {
          value: 'totalDirectCompensationUSD',
          text: 'C4: Total Direct Compensation',
          isSummary: true,
        },
        {
          value: 'perquisiteUSD',
          text: 'Perquisites',
          isSummary: false,
          tip: "Eg. Benefits such as Value of Car, Children's education, Housing",
          components: ['perquisiteUSD'],
        },
        {
          value: 'totalRemunerationUSD',
          text: 'C5: Total Remuneration',
          isSummary: true,
        },
        {
          value: 'pensionUSD',
          text: 'Pension',
          isSummary: false,
          tip: 'Mandatory such as CPF or supplementary',
          components: ['pensionUSD'],
        },
        {
          value: 'totalCostUSD',
          text: 'C6: Total Cost to Company',
          isSummary: true,
        },
      ],
    };
  },
  computed: {
    pvalRows() {
      const out = {};
      this.rows.forEach((row) => {
        const values = this.benefits[row.value];
        if (!values) {
          return;
        }
        values.sort((a, b) => a - b);
        const p10 = pval(values, 10);
        const p25 = pval(values, 25);
        const p50 = pval(values, 50);
        const p75 = pval(values, 75);
        const p90 = pval(values, 90);
        const m = this.mean(values);

        let p10AsPcOfABS = 0;
        let p25AsPcOfABS = 0;
        let p50AsPcOfABS = 0;
        let p75AsPcOfABS = 0;
        let p90AsPcOfABS = 0;
        let meanAsPcOfABS = 0;
        if (row.components) {
          const valuesAsPcOfABS = this.benefits[`${row.value}AsPcOfABS`];
          if (valuesAsPcOfABS) {
            valuesAsPcOfABS.sort((a, b) => a - b);
            p10AsPcOfABS = pval(valuesAsPcOfABS, 10);
            p25AsPcOfABS = pval(valuesAsPcOfABS, 25);
            p50AsPcOfABS = pval(valuesAsPcOfABS, 50);
            p75AsPcOfABS = pval(valuesAsPcOfABS, 75);
            p90AsPcOfABS = pval(valuesAsPcOfABS, 90);
            meanAsPcOfABS = this.mean(valuesAsPcOfABS);
          }
        }
        out[row.value] = {
          p10,
          p25,
          p50,
          p75,
          p90,
          mean: m,
          p10AsPcOfABS,
          p25AsPcOfABS,
          p50AsPcOfABS,
          p75AsPcOfABS,
          p90AsPcOfABS,
          meanAsPcOfABS,
        };
      });
      return out;
    },
    totalPositions() {
      const { companyBenefits } = this;
      let count = 0;
      companyBenefits.forEach((compBen) => {
        count += compBen.positions.length;
      });
      return count;
    },
    benefits() {
      const benefits = {};
      const { companyBenefits, rows } = this;
      const { usdDivisor } = this.exchangeRate;
      companyBenefits.forEach((cb) => {
        cb.positions.forEach((pos) => {
          rows.forEach((row) => {
            if (row.isSummary) {
              if (pos.totalCostUSD) {
                if (benefits[row.value]) {
                  benefits[row.value].push(pos[row.value] * usdDivisor);
                } else {
                  benefits[row.value] = [pos[row.value] * usdDivisor];
                }
              }
            } else if (pos[row.value]) {
              if (benefits[row.value]) {
                benefits[row.value].push(pos[row.value] * usdDivisor);
              } else {
                benefits[row.value] = [pos[row.value] * usdDivisor];
              }
              if (row.components && pos.salaryUSD) {
                if (benefits[`${row.value}AsPcOfABS`]) {
                  benefits[`${row.value}AsPcOfABS`].push(pos[row.value] / pos.salaryUSD);
                } else {
                  benefits[`${row.value}AsPcOfABS`] = [pos[row.value] / pos.salaryUSD];
                }
              }
            }
          });
        });
      });

      return benefits;
    },
    rows() {
      return this.c1c6View ? this.rowsC1c6 : this.rowsRaw;
    },
  },
  components: {
    Benchmark,
  },
  methods: {
    hasIncumbents(row, benefits) {
      return benefits[row.value] && benefits[row.value].length > 0;
    },
    getClass(r) {
      let cls = 'yellow black--text text--darken-3';
      if (r.isSummary) {
        cls += ' lighten-4 summary';
      } else {
        cls += ' lighten-5';
      }
      if (r.components) {
        cls += ' withpercen';
      } else if (!r.isSummary) {
        cls += ' dense';
      }
      return cls;
    },

    exportToExcel() {
      const values = {
        sectors: this.sectors,
        onetJobGroups: this.onetJobGroups,
        countries: this.countries,
        jobClasses: this.jobClasses.map((jc) => {
          if (jc === 'All') {
            return -1;
          }
          return jc;
        }),
        currency: this.exchangeRate.currencyCode,
        benefits: this.benefits,
        companies: this.companyBenefits.map((cb) => cb.company),
        c1c6: this.c1c6View,
        totalPositions: this.totalPositions,
      };
      fetch('/exec-comp/api/exportToExcel', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      })
        .then((data) => data.blob())
        .then((file) => {
          download(file, 'Compensation Report.xlsx', file.type);
        })
        // eslint-disable-next-line
        .catch((err) => console.error(err));
    },
    pval,
    mean(array) {
      if (array === null || typeof array === 'undefined') {
        return '';
      }
      const sum = array.reduce((a, b) => a + b);
      return sum / array.length;
    },
  },
});
</script>
<style lang="css" scoped>
thead th {
  color: rgba(0, 0, 0, 0.54);
}
td {
  border-bottom: 0 !important;
}

tr.summary td {
  font-weight: 600 !important;
}

tr.withpercen td {
  padding-top: 8px !important;
  height: 30px !important;
}
tr.dense td {
  height: 44px !important;
}

tr.percent td {
  padding-bottom: 8px !important;
  height: 30px !important;
  font-style: italic !important;
  font-weight: 400 !important;
}
</style>
